var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hideWarning)?_c('div',{staticClass:"alert alert-warning text-center",class:{ 'hide': _vm.hideWarning},attrs:{"role":"alert"}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-warning","iconId":"icon-warning"}}),_vm._v(" "+_vm._s(_vm.warningMessage)+" "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }